import * as contentful from 'contentful';
import { CreateClientParams } from 'contentful';
import * as contentfulManagement from 'contentful-management';

export const config = {
	CONTENTFUL_SPACE_ID: String(process.env.CONTENTFUL_SPACE_ID),
	CONTENTFUL_DELIVERY_TOKEN: String(process.env.CONTENTFUL_DELIVERY_TOKEN),
	CONTENTFUL_ENVIRONMENT: String(process.env.CONTENTFUL_ENVIRONMENT)
};

export function getManagementClient(accessToken: string) {
	return contentfulManagement.createClient({
		accessToken
	});
}

export function getDeliveryClient(params?: Partial<CreateClientParams>) {
	return contentful.createClient({
		space: config.CONTENTFUL_SPACE_ID,
		accessToken: config.CONTENTFUL_DELIVERY_TOKEN,
		environment: config.CONTENTFUL_ENVIRONMENT,
		...(params ?? {})
	});
}
